export default function TextLogo({ link }: { link: boolean }) {
    function MoveRoot() {
        if (link) {
            window.location.href = '/'
        }
    }
    return (
        <div className={`logo text-logo-patek ${link ? '--pointer' : ''}`} onClick={MoveRoot}>
            <span className="text-logo-brand">Patek Casino</span>
        </div>
    )
}

TextLogo.defaultProps = {
    link: false
}